import styled, { keyframes } from 'styled-components';

const slideInFromLeft = keyframes`
  0% {
    transform: translateX(-20%);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const Container = styled.div`
  margin-top: 100px;
  position: relative;
  width: 100%;
  height: 300px;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 268px;
  }
`;

const zoomIn = keyframes`
  0% { transform: scale(1); }
  100% { transform: scale(1.2); }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: brightness(80%) contrast(100%) saturate(140%);
  animation: ${zoomIn} 4s cubic-bezier(0.42, 0, 0.58, 1) forwards;
`;

export const Titulo = styled.h1`
  position: absolute;
  top: 54%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  text-align: center;
  font-size: 4vw;
  z-index: 3;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 6vw;
  }
`;

export const Line1 = styled.span`
  font-family: 'GarnetLight';
  animation: ${slideInFromLeft} 1.8s cubic-bezier(0.7, -0.5, 0.3, 1.2);
  display: block;
  position: relative;

  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 99%;
    height: 5px;
    background: linear-gradient(to right, transparent, #a0f000);
    bottom: -2px;
    right: 0;
  }
`;

export const LogoContainer = styled.div`
  animation: fadeIn 2s ease-in-out forwards;
  opacity: 0;

  img{
    width: 580px;
  }

  @media (max-width: 768px){
    img{
     width: 340px;
    }
  }

  @media (max-width: 480px){
    img{
       width: 340px;
    }
  }
`;
/* ----------------------------- */
/*  BANNER INFERIOR NUEVO        */
/* ----------------------------- */
export const BannerInferior = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #055A34;
  margin-top: 0;

  @media (max-width: 768px) {
    height: 40px;
  }
`;

/* Contenedor que centra el texto + logo */
export const ContenidoInferior = styled.div`
  display: flex;
  align-items: center;
  gap: 15px; 
  justify-content: center;
`;

/* Texto "Patrocinado por:" */
export const Patrocinado = styled.span`
 animation: ${slideInFromLeft} 1.8s cubic-bezier(0.7, -0.5, 0.3, 1.2);
  color: white;
  font-size: 16px;
  font-weight: bold;
  font-family: Arial, sans-serif;
   font-family: 'GarnetLight';

  @media (max-width: 768px) {
    font-size: 8px;
  }
`;

export const LogoCRSur = styled.img`
  height: 80px;
  width: auto;
  animation: fadeIn 2s ease-in-out forwards;

  @media (max-width: 768px) {
    height: 35px;
  }
`;
